import { LuSelectType } from './lu-select.models';

export class LuSelectService {
	// any should be LuSelectService but there is angular Dependecy warning
	constructor(private selectInstance: any) {}

	updateItems(items: any[]): void {
		this.selectInstance.items = [...items];
	}

	/**
	 * Get selected item object from lu-select
	 */
	getSelectedItem(): any {
		return this.selectInstance.selectedItem;
	}

	/**
	 * Get items
	 */
	getItems(): any[] {
		return this.selectInstance.originalItems;
	}

	/**
	 * Set default lu-select value when we have API or Offline select.
	 */
	setSelectedItem(item: any): void {
		// we'd need to wait for CD to finish and render field - schedule microtask
		// so we can update model afterwards on selectItem
		Promise.resolve(null).then(() => {
			this.selectInstance.selectedItem = item;
			this.selectInstance.sendDataToParentComp();
		});
	}

	/**
	 * Get Selected Item main field for announcer or any other purpose
	 */
	getSelectItemField(): string {
		const { options } = this.selectInstance;
		const { itemOptions } = options;
		switch (itemOptions?.type) {
			case LuSelectType.BASIC:
			case LuSelectType.IMAGE:
				return itemOptions.primaryField.field;
		}
	}
}
